import React from 'react';
import { ScanLine } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="bg-slate-900 text-slate-400 py-12 border-t border-slate-800" data-id="element-2333" data-mp="3ggaovpzpm32t">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2334" data-mp="32onjn0nshk7w">
        <div className="grid md:grid-cols-4 gap-8 mb-12" data-id="element-2335" data-mp="36pfshssr1n3n">
          <div className="col-span-1 md:col-span-2" data-id="element-2336" data-mp="36pzblcu4yhj9">
            <Link to="/" className="flex items-center space-x-2 mb-4 group" data-id="element-2337" data-mp="3ufa5cad2jbnw">
              <img src="https://cdn.magicpatterns.com/uploads/kYypn9DLGTyuEjc1d2cJka/intellieats_icon.webp" alt="IntelliEats icon" className="h-8 w-8 rounded-lg shadow-lg group-hover:shadow-brand-500/20 transition-all duration-300" data-id="element-2338" data-mp="3ud7i1y3avwmv" />
              <span className="text-xl font-bold text-white tracking-tight" data-id="element-2339" data-mp="3qf9raqtvt2hd">
                Intelli<span className="text-brand-500" data-id="element-2340" data-mp="29xvqkc20tbos">Eats</span>
              </span>
            </Link>
            <p className="text-sm max-w-xs leading-relaxed" data-id="element-2341" data-mp="2ezl4bzgmo3gk">
              Empowering you to make healthier food choices through intelligent
              ingredient analysis. Scan, detect, and eat smarter.
            </p>
          </div>

          <div data-id="element-2342" data-mp="3v7ggw4mssibe">
            <h3 className="text-white font-bold mb-4" data-id="element-2343" data-mp="3v7zw3dl2cslq">Product</h3>
            <ul className="space-y-2 text-sm" data-id="element-2344" data-mp="3q8mzw28ay96h">
              <li data-id="element-2345" data-mp="3q7u1bojhypzf">
                <a href="/#how-it-works" className="hover:text-brand-400 transition-colors" data-id="element-2346" data-mp="3q7bvq1ay2zeu">
                  How It Works
                </a>
              </li>
              <li data-id="element-2347" data-mp="31up7hdvubpd">
                <a href="/#features" className="hover:text-brand-400 transition-colors" data-id="element-2348" data-mp="hstrybs1e611">
                  Features
                </a>
              </li>
              <li data-id="element-2349" data-mp="qt8fziwdxz88">
                <Link to="/blog" className="hover:text-brand-400 transition-colors" data-id="element-2350" data-mp="qsqfub6lr0v1">
                  Blog
                </Link>
              </li>
              <li data-id="element-2351" data-mp="tw5xq4ifnmlo">
                <a href="/#download" className="hover:text-brand-400 transition-colors" data-id="element-2352" data-mp="two3brqzjd69">
                  Download
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-2353" data-mp="18k0qtm0crsza">
            <h3 className="text-white font-bold mb-4" data-id="element-2354" data-mp="18jr3652s5xwr">Legal</h3>
            <ul className="space-y-2 text-sm" data-id="element-2355" data-mp="18m3sx4es5ckd">
              <li data-id="element-2356" data-mp="1cmdwkaf3nqw2">
                <Link to="/privacy" className="hover:text-brand-400 transition-colors" data-id="element-2357" data-mp="1ckt2sn0m0bz9">
                  Privacy Policy
                </Link>
              </li>
              <li data-id="element-2358" data-mp="1mkjwwnl9coyt">
                <Link to="/terms" className="hover:text-brand-400 transition-colors" data-id="element-2359" data-mp="1mhxpqp2a4bh4">
                  Terms of Service
                </Link>
              </li>
              <li data-id="element-2360" data-mp="3ta8c1ohfn9dm">
                <Link to="/editorial-policy" className="hover:text-brand-400 transition-colors" data-id="element-2361" data-mp="3t9q805oj3qv5">
                  Editorial Policy
                </Link>
              </li>
              <li data-id="element-2362" data-mp="25nlrf11390y4">
                <Link to="/contact" className="hover:text-brand-400 transition-colors" data-id="element-2363" data-mp="25n3yad9q32uf">
                  Contact Support
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-slate-800 flex flex-col md:flex-row justify-between items-center text-sm" data-id="element-2364" data-mp="2te99gf4px6ye">
          <p data-id="element-2365" data-mp="2pcw5kal6rdu4">© {new Date().getFullYear()} IntelliEats. All rights reserved.</p>
          <p className="mt-2 md:mt-0" data-id="element-2366" data-mp="2kc8ghugip72j">Developed by IntelliEats Team</p>
        </div>
      </div>
    </footer>;
}